// import React, { useState } from 'react';
import { Coffee } from 'lucide-react';

function DonationButton() {
  // const [showWallets, setShowWallets] = useState(false);
  // const wallets = {
  //   bitcoin: 'bc1qr666dp53muf62u73qdkglgzzhpnfhl7h6yad22',
  //   ethereum: '0xc4a4c0Cf515233F48018a3AD194D1Ac0Cde999e0'
  // };

  return (
    <div>
      <a href="https://www.buymeacoffee.com/immanuwell" target="_blank" rel="noreferrer" style={{ textDecoration:'none', textAlign: 'center', alignItems: 'center', marginTop:'0' }}>
      <button
        // onClick={() => setShowWallets(!showWallets)}
        className="bg-blue-300 text-white px-4 py-2 rounded-lg flex items-center gap-2 mx-auto hover:bg-blue-600"
      >
        <Coffee size={20} />
        Buy me a coffee
      </button>
      </a>

      {/* {showWallets && (
        <div className="w-fit mx-auto mt-2 p-4 bg-gray-100 text-center">
          <p className="mb-2 text-sm">
            <strong>Bitcoin:</strong> {wallets.bitcoin}
          </p>
          <p className="mb-2 text-sm">
            <strong>Ethereum:</strong> {wallets.ethereum}
          </p>
        </div>
      )} */}
    </div>
  );
}

export default DonationButton;
